<template>
    <canvas v-if="canvasId" :id="canvasId" @mousedown="handleMouseDown" @ontouchstart="handleMouseDown" @mouseup="handleMouseUp" @touchend="handleMouseUp" @mousemove="handleMouseMove" @ontouchmove="handleMouseMove" :width="width" :height="height"></canvas>
</template>

<script>
    export default {
        props:{
            width:{
                type:String,
                default:'800px'
            },
            height:{
                type:String,
                default:'800px'
            },
            color:{
                type:String,
                default:"#333333"
            },
            lineWidth:{
                type:Number,
                default:10
            },
            background:{
                type:String
            }
        },
        data(){
            return {
                canvasId:null,
                mouse: {
                    current: {
                        x: 0,
                        y: 0
                    },
                    previous: {
                        x: 0,
                        y: 0
                    },
                    down: false
                }
            }
        },

        computed: {
            currentMouse(){
                var c = document.getElementById(this.canvasId);
                var rect = c.getBoundingClientRect();
                
                return {
                        x: this.mouse.current.x - rect.left,
                        y: this.mouse.current.y - rect.top
                    }
            }
        },
        methods: {
            draw(){
            
            if (this.mouse.down) {
                var c = document.getElementById(this.canvasId);
                var ctx = c.getContext("2d");
                ctx.clearRect(0,0,this.width,this.height);
                ctx.lineTo(this.currentMouse.x, this.currentMouse.y);
                ctx.strokeStyle =this.color;
                ctx.lineWidth = this.lineWidth;
                ctx.stroke()
            }
            
            },
            handleMouseDown(event){
                this.mouse.down = true;
                this.mouse.current = {
                    x: event.pageX,
                    y: event.pageY
                }

                var c = document.getElementById(this.canvasId);
                var ctx = c.getContext("2d");
                ctx.moveTo(this.currentMouse.x, this.currentMouse.y)
            },
            handleMouseUp(){
                this.mouse.down = false;
            },
            handleMouseMove(event){
                this.mouse.current = {
                    x: event.pageX,
                    y: event.pageY
                }
                this.draw(event);
            },
        },
        mounted() {
            this.canvasId='canvas_'+new Date().getTime(); 

            this.$nextTick(()=>{
                var c = document.getElementById(this.canvasId);
                c.style.setProperty(`--bgName`,`url('${this.background}') no-repeat no-repeat center fixed`);
                var ctx = c.getContext("2d");
                ctx.translate(0.5, 0.5);
                ctx.imageSmoothingEnabled= false;
            });
        }
}
</script>

<style scoped>
    canvas {
        margin: 0px 0px 0px 0px;
        background:var(--bgName, black no-repeat no-repeat center fixed);
        -webkit-background-size: contain;
        -moz-background-size: contain;
        -o-background-size: contain;
        background-size: contain;
    }
</style>